// extracted by mini-css-extract-plugin
module.exports = {"newMain":"news_newMain__1EuuM","mainTitle":"news_mainTitle__1MKyL","mainSubTitle":"news_mainSubTitle__fqhzj"};